import React from "react";
import PropTypes from "prop-types";

const VisuallyHidden = props => {
  return <span className="et--visually-hidden">{props.children}</span>;
};

VisuallyHidden.propTypes = {};

export default VisuallyHidden;
